import { render, staticRenderFns } from "./EmptyLoadingPage.vue?vue&type=template&id=7af8d476&scoped=true"
import script from "./EmptyLoadingPage.vue?vue&type=script&lang=js"
export * from "./EmptyLoadingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af8d476",
  null
  
)

export default component.exports